import styled from "styled-components";

export const SubsModule = styled.div`
	width: 50%;
	display: flex;
	flex-direction: column;
	flex: 1;
	min-height: 0;
`;
